<template>
  <div
    class="c-blogSalesPromote"
    id="blogSalesPromote"
  >
    <div
      class="c-blogSalesPromote_title"
      v-if="!isFromCoconalaApp"
    >
      この続きは購入すると読めるようになります。
    </div>
    <div class="c-blogSalesPromote_paidAreaInfo">{{ paidAreaInfoText }}</div>
    <div class="c-blogSalesPromote_itemWrapper">
      <div class="c-blogItem">
        <div class="c-heading">
          <div class="c-heading_title">
            {{ $util.truncate(this.blog.title, maxTitle) }}
            <span class="c-heading_kind">
              <CoconalaIcon
                :name="kindIconName"
                :size="kindIconSize"
              />
              {{ kindText }}
            </span>
          </div>
          <div class="c-heading_category">{{ blog.blogCategory.name }}</div>
        </div>
        <img
          class="c-blogItem_coverImg"
          v-if="blog.coverImageUrl"
          :src="blog.coverImageUrl"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div v-if="!isFromCoconalaApp">
        <div class="c-blogItem_price">
          {{ blog.price | withDelimiter }}円
          <span
            class="c-blogItem_orderCount"
            v-if="blog.paidOrdersCount"
          >{{ blog.paidOrdersCount }}人が購入しています</span>
        </div>
        <CButtonV2
          :width="'100%'"
          color="primary"
          no-shadow
          :size="isPC ? 'l' : 'm'"
          @click="$emit('goToPayment', $event)"
        >記事を購入する</CButtonV2>
      </div>
    </div>
    <div
      class="c-blogSalesPromote_loginAction"
      v-if="!isLoggedIn && !isFromCoconalaApp"
    >
      <CButtonV2
        :width="'100%'"
        color="secondary"
        :size="isPC ? 'l' : 'm'"
        :href="$coconala.loginURL($route.fullPath)"
      >すでに購入済みの方はログイン</CButtonV2>
    </div>
  </div>
</template>

<script>
// vuex
import { mapGetters, mapState } from 'vuex'

const MAX_TITLE_PC = 44
const MAX_TITLE_SP = 18

export default {
  name: 'BlogSalesPromote',
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isFromCoconalaApp']),
    ...mapGetters('ui', ['isPC']),
    ...mapState('pages/blogs/user/blog', ['blog']),
    ...mapState('pages/blogs/constants', ['KIND']),
    ...mapGetters('pages/users', ['isOwner']),
    isKindNormal() {
      return this.blog.kind === this.KIND.NORMAL
    },
    isKindContents() {
      return this.blog.kind === this.KIND.CONTENTS
    },
    isKindAnnounce() {
      return this.blog.kind === this.KIND.ANNOUNCE
    },
    kindIconName() {
      if (this.isKindNormal) return 'blog-article'
      if (this.isKindContents) return 'blog-content'
      if (this.isKindAnnounce) return 'blog-announce'
      return 'blog-article'
    },
    kindIconSize() {
      if (this.isKindNormal) return '12px'
      if (this.isKindContents) return '12px'
      if (this.isKindAnnounce) return '11px'
      return '12px'
    },
    kindText() {
      return this.$store.getters['pages/blogs/constants/kindText'](this.blog.kind)
    },
    maxTitle() {
      return this.isPC ? MAX_TITLE_PC : MAX_TITLE_SP
    },
    paidAreaInfoText() {
      // 有料記事ブログは1000文字以上が必須なので、1000文字未満の場合は想定外のため何も表示しない
      if (this.isKindNormal && this.blog.paidBodyCharCount < 1000) {
        return ''
      }
      // コンテンツの場合で文字がない場合は文字の表記を取る
      if (this.isKindContents && this.blog.paidBodyCharCount === 0) {
        if (this.blog.paidImagesCount > 0 && this.blog.paidVideosCount > 0) {
          return `残り：画像${this.blog.paidImagesCount}枚 / 動画${this.blog.paidVideosCount}本`
        }
        if (this.blog.paidImagesCount > 0) {
          return `残り：画像${this.blog.paidImagesCount}枚`
        }
        if (this.blog.paidVideosCount > 0) {
          return `残り：動画${this.blog.paidVideosCount}本`
        }
      } else {
        let text = `残り：${this.$util.numberWithDelimiter(this.blog.paidBodyCharCount)}文字`
        if (this.blog.paidImagesCount > 0) {
          text += ` / 画像${this.blog.paidImagesCount}枚`
        }
        if (this.blog.paidVideosCount > 0) {
          text += ` / 動画${this.blog.paidVideosCount}本`
        }
        return text
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-blogSalesPromote {
  margin: 40px 0;
  border-top: 2px dashed $color-gray-200;

  &_title {
    margin-top: 20px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }

  &_paidAreaInfo {
    margin-top: 8px;
    text-align: center;
    font-size: 14px;
  }

  &_itemWrapper {
    margin-top: 8px;
    padding: 24px 40px;
    border: 1px solid $color-gray-200;
    border-radius: 4px;
  }

  &_loginAction {
    margin: 24px 40px;
  }
}
.c-blogItem {
  display: flex;
  padding: 16px 12px 0;

  justify-content: space-between;

  &_coverImg {
    width: 120px;
    height: 67px;
    border-radius: 6px;
  }

  &_price {
    margin: -8px 0 12px;
    padding: 0 12px;
    font-weight: bold;
  }

  &_orderCount {
    display: inline-block;
    margin-left: 8px;
    padding: 3px 8px;
    border: 0;
    border-radius: 12px;
    background: $color-green-50;
    color: $color-green-500;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
  }

  ._noticeAppIos {
    font-size: 12px;
  }
}

.c-heading {
  &_title {
    margin-bottom: 8px;
    padding-right: 16px;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.3;
  }

  &_kind {
    display: inline-block;
    color: $color-gray-600;
    font-weight: normal;
    font-size: 12px;
  }

  &_category {
    margin-bottom: 8px;
    color: $color-gray-600;
    font-size: 12px;
  }
}

@media (max-width: $breakpoint-m) {
  .c-blogSalesPromote {
    &_title {
      margin: 20px 46px 0;
    }

    &_itemWrapper {
      padding: 20px 16px;
    }

    &_loginAction {
      margin: 20px 16px;
    }
  }

  .c-blogItem {
    margin-bottom: 12px;
    padding: 0;

    &_coverImg {
      width: 100px;
      height: 56px;
    }

    &_price {
      padding: 0;
    }
  }

  .c-heading {
    &_title {
      margin-bottom: 0;
    }
  }
}

@media (max-width: $breakpoint-s) {
  .c-blogItem {
    &_orderCount {
      margin-left: 4px;
    }
  }
}
</style>
